import { setTerm } from './helpers';
import { TJsonQuery } from './types';

export function setWithoutAgentCall(jsonQuery: TJsonQuery) {
  return (value: boolean | null): TJsonQuery => setTerm('cl')(jsonQuery)(value === true ? false : null);
}
